module.exports = __webpack_public_path__ + "static/assets/9a60e8b984901f16900ceb8e21040fc6.svg";